import { render, staticRenderFns } from "./orderViewUser.vue?vue&type=template&id=0ae1a5c7&"
import script from "./orderViewUser.vue?vue&type=script&lang=js&"
export * from "./orderViewUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports